"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = void 0;
const react_1 = __importDefault(require("react"));
/**
 * A React hook that fires a callback function whenever the user clicks on
 * outside of a given HTML element.
 * @param element React reference to the HTML element
 * @param onClickOutside the callback function fired when the user clicks
 * outside of the referenced HTML element
 * @example
 * const element = React.useRef<HTMLDivElement>(null);
 * const [hasClickedOutside, setHasClickedOutside] = React.useState(false);
 *
 * useClickOutside(element, () => setHasClickedOutside(true));
 *
 * <Box ref={element} />
 */
const useClickOutside = (element, onClickOutside) => {
    react_1.default.useEffect(() => {
        const handleClick = (e) => {
            var _a;
            if (
            // Don't trigger if the target has been removed entirely
            document.contains(e.target) &&
                !((_a = element.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                onClickOutside();
            }
        };
        window.addEventListener("click", handleClick);
        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, [element, onClickOutside]);
};
exports.useClickOutside = useClickOutside;
//# sourceMappingURL=useClickOutside.js.map